// APP_CONSTANTS.js
// Reads from window.ENV_CONFIG which is set by public/config/env-config.js
// This allows changing configuration without rebuilding!

const getConfig = () => {
  // Fallback values if ENV_CONFIG is not loaded yet
  const defaults = {
    CENTER_RADIOLOGY_URL: '',
    BACKEND_API: 'https://demo-api.photonpacs.com/api',
    CENTER_HAS_INVALID_PATIENT_IDS: true,
    IDLE_TIMEOUT_ENABLED: false,
    IDLE_TIMEOUT_MINUTES: 300,
    IS_ACR_PACS: false,
    WADO_URI_ROOT: 'https://demo-api.photonpacs.com/dicom/aets/DCM4CHEE/rs',
    CENTER_NAME: 'Photon PACS - QA',
    REPORT_HEADER_FOOTER_ALL_PAGES: true,
    DICOM_PARALLEL_DOWNLOADS: 20,
    ENABLE_AGGREGATED_STATS: false,
    DISABLE_DEFAULT_FILTERS: false,
  };

  return typeof window !== 'undefined' && window.ENV_CONFIG
    ? window.ENV_CONFIG
    : defaults;
};

const config = getConfig();

const CENTER_RADIOLOGY_URL = config.CENTER_RADIOLOGY_URL;
const BACKEND_API = config.BACKEND_API;
const CENTER_HAS_INVALID_PATIENT_IDS = config.CENTER_HAS_INVALID_PATIENT_IDS;
const IDLE_TIMEOUT_ENABLED = config.IDLE_TIMEOUT_ENABLED;
const IDLE_TIMEOUT_MINUTES = config.IDLE_TIMEOUT_MINUTES;
const IS_ACR_PACS = config.IS_ACR_PACS;
const CENTER_NAME = config.IS_ACR_PACS || 'Photon PACS - QA';
const REPORT_HEADER_FOOTER_ALL_PAGES = config.REPORT_HEADER_FOOTER_ALL_PAGES;
const DICOM_PARALLEL_DOWNLOADS = config.DICOM_PARALLEL_DOWNLOADS;
const ENABLE_AGGREGATED_STATS = config.ENABLE_AGGREGATED_STATS;
const DISABLE_DEFAULT_FILTERS = config.DISABLE_DEFAULT_FILTERS;

// Legacy - kept for backward compatibility
const VIEWER_API = config.WADO_URI_ROOT || 'https://demo-api.photonpacs.com/dicom/aets/DCM4CHEE/rs';

module.exports = {
  VIEWER_API,
  CENTER_RADIOLOGY_URL,
  BACKEND_API,
  CENTER_HAS_INVALID_PATIENT_IDS,
  IDLE_TIMEOUT_ENABLED,
  IDLE_TIMEOUT_MINUTES,
  IS_ACR_PACS,
  CENTER_NAME,
  REPORT_HEADER_FOOTER_ALL_PAGES,
  DICOM_PARALLEL_DOWNLOADS,
  ENABLE_AGGREGATED_STATS,
  DISABLE_DEFAULT_FILTERS,
};

